import Alpine from 'alpinejs';
import './edit-lock';
import './screen-guide';
import { registerMoneyDirective } from './money-input';

window.Alpine = Alpine;

registerMoneyDirective(Alpine);

Alpine.start();
